import {createSvgIcon} from './utils'

export const UploadIcon = createSvgIcon(
  <>
    <path
      d="M16.7072 6.70711L15.293 8.12132L13.0001 5.82843L13.0001 17H11.0001V5.82843L8.70717 8.12132L7.29295 6.70711L12.0001 2L16.7072 6.70711Z"
      fill="#21201F"
    />
    <path
      d="M16 20H8C7.04075 20 6.42148 19.9989 5.94752 19.9666C5.49152 19.9355 5.31786 19.8822 5.23463 19.8478C4.74458 19.6448 4.35523 19.2554 4.15224 18.7654C4.11777 18.6821 4.06453 18.5085 4.03342 18.0525C4.00108 17.5785 4 16.9592 4 16V11H2V16C2 17.8638 2 18.7957 2.30448 19.5307C2.71046 20.5108 3.48915 21.2895 4.46927 21.6955C5.20435 22 6.13623 22 8 22H16C17.8638 22 18.7956 22 19.5307 21.6955C20.5108 21.2895 21.2895 20.5108 21.6955 19.5307C22 18.7957 22 17.8638 22 16V11H20V16C20 16.9592 19.9989 17.5785 19.9666 18.0525C19.9355 18.5085 19.8822 18.6821 19.8478 18.7654C19.6448 19.2554 19.2554 19.6448 18.7654 19.8478C18.6821 19.8822 18.5085 19.9355 18.0525 19.9666C17.5785 19.9989 16.9592 20 16 20Z"
      fill="#21201F"
    />
  </>,
  'Upload',
)
